import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck, FaAward, FaTag, FaHeadset } from 'react-icons/fa';
import { content } from '@/content/sr';

const iconMap = {
  truck: FaTruck,
  award: FaAward,
  tag: FaTag,
  headphones: FaHeadset,
};

const Benefits = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section className="section-padding bg-white" data-testid="benefits-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="caption text-brand-accent block mb-4"
          >
            {content.benefits.caption}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-4xl md:text-5xl font-light text-brand-primary"
          >
            {content.benefits.title}
          </motion.h2>
        </div>

        {/* Benefits Grid - Bento Style */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {content.benefits.items.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                className="feature-card group"
                data-testid={`benefit-card-${index}`}
              >
                <div className="w-14 h-14 rounded-sm bg-brand-bgSoft flex items-center justify-center mb-6 
                              group-hover:bg-brand-accent transition-colors duration-300">
                  <Icon className="w-6 h-6 text-brand-accent group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-heading text-xl font-medium text-brand-primary mb-3">
                  {item.title}
                </h3>
                <p className="text-neutral-500 text-sm leading-relaxed">
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
